<!-- 个人中心 - 回收站页 -->

<template>
  <div id="framework-content">
    <!-- 当前位置 -->
    <div class="content-position">操作记录-删除的证据</div>
    <!-- 内容区域 -->
    <div class="content-main" style="padding-top: 20px;">
      <table class="table">
        <tr>
          <td style="width: 17%">关键词</td>
          <td style="width: 30%">证据链接</td>
          <td style="width: 17%">取证时间</td>
          <td style="width: 17%">查看证书</td>
          <td style="width: 19%">操作</td>
        </tr>
        <tr v-for="(result, index) in datas.data">
          <td>{{result.sourceTitle}}</td>
          <td :title="result.evidenceName" @click="openPage(result.sourceUrl, false)" class="url">{{result.sourceUrl}}</a></td>
          <td>{{result.evidenceFinishTime}}</td>
          <td :class="[{failed:result.saveStatus==3}]">
              <span class="addHoverColor" v-if="result.saveStatus == 2" @click="openPage(result.detailUrl, true)">
                {{result.statusDesc}}
              </span>
              <span v-else>
                  {{result.statusDesc}}
                  <span class="extra">{{result.extralDesc}}</span>
              </span>
          </td>
          <td class="data-actions">
            <span class="icon-box icon-recover" title="还原" style="left: 30%"  @click.stop="restoreRecord(result.id, index)"></span>
            <span class="icon-box icon-delete" title="彻底删除" style="left: 58%" @click.stop="confirmDel(result.id)"></span>
          </td>
        </tr>
      </table>
      <div class="no-data" v-if="!hasData">
        <img src="../../assets/images/personal/nodata.png">
        <p>&nbsp;&nbsp;&nbsp;&nbsp;您目前还没有数据...</p>
      </div>
      <paging-personal  :pageInfo="pageInfo" :isAsync="true" style="margin-top: 15px;"></paging-personal>
    </div>
    <action-modal @handleFunc="execFunc"
                  :msg="modalInfo.msg"
                  :isShown="modalInfo.isShown"
                  :buttons="modalInfo.buttons"
    ></action-modal>
  </div>
</template>


<style scoped>
.addHoverColor{
  cursor: pointer;
}
.addHoverColor:hover{
  color: #c45!important;
}
</style>

<script>
  import PagingPersonal from '@/components/common/PagingPersonal'
  import Loading from '@/components/common/Loading'
  import ActionModal from '@/components/common/ActionModal'
  import moment from 'moment'

  export default {
    name: 'Trash',
    components: {PagingPersonal, ActionModal, Loading},
    mounted(){
      this.userInfo = this.$getLocalStorage('IP360', 'user');
      let path = this.$router.currentRoute.path;
      this.$emit('childChange', path.substring(path.lastIndexOf('/')));
      this.dataRequest();
    },
    data() {
      return {
        datas:{
          data: [],
          page: {
            firstPage: false,
            lastPage: false
          }
        },
        pageNum: 1,
        delId:0,
        statusDesc:['排队中', '正在存证', '查看证书', '存证失败'],
        modalInfo:{
          msg: 'test',
          isShown: false,
          buttons:[
            {
              desc: '确定',
              func: 'removeRecord',
            },{
              desc: '取消',
              func: 'closeModal',
            }
          ]
        },
        hasData: true,
        userInfo: {},
        isAsync: true,
        pageInfo:{
          pageNumber:1,
          pageSize:10
        }
      }
    },
    methods: {
      goto(pageNum){
        this.pageNum = parseInt(pageNum);
        this.dataRequest();
      },
      openPage(url, gotoIP360){
        if(url.indexOf('/') === 0){
          url = GlobalConfig.ip360Url + url;
        }
        if(gotoIP360){
          if(url.indexOf('?') < 0){
            url += '?u=' + this.userInfo.id + '&t=' + this.userInfo.token + '&from=truthso_search';
          }else{
            url += '&u=' + this.userInfo.id + '&t=' + this.userInfo.token + '&from=truthso_search';
          }
        }
        console.log('url:', url);
        window.open(url);
      },
      execFunc(func){
        if(this[func] && typeof this[func] == 'function'){
          this[func]();
        }else{
          console.log(func + ' is not valid function');
        }
      },
      dataRequest(){
        this.$store.commit('showLoadingPersonal',true);
        let statusDesc = this.statusDesc;

        let query = this.$router.history.current.query
        let pageNo = query.pageNumber ? query.pageNumber : 1;
        let pageSize = query.pageSize ? query.pageSize : 10;

        this.$axios.request({
          url: '/webapi/personal/getTaskListByPage',
          method: 'get',
          params: {
            operatorId: this.userInfo.id,
            pageNo,
            pageSize,
            searchType: 2,
            token: this.userInfo.token,
            timestamp:new Date().getTime()
          }
        }).then((response) => {
          this.$store.commit('showLoadingPersonal',false);
          let result = response.data;
          if(result.code == 200){

            let pageInfo = {};
            pageInfo.pageNumber = result.datas.result.pageNumber;
            pageInfo.pageSize = result.datas.result.pageSize;
            pageInfo.totalPage = result.datas.result.totalPage;
            pageInfo.totalRow = result.datas.result.totalRow;
            this.pageInfo = pageInfo;

            if(result.datas.result.list.length > 0){
              this.hasData = true;
            } else {
              this.hasData = false;
            }
            result.datas.result.list.forEach(function(item){
              item.showAction = false;
              item.statusDesc = statusDesc[item.saveStatus];
              result.payStatus = 3;
              item.extralDesc = "";
              item.detailUrl = '';
              if(item.saveStatus == 2){
                if(item.evidenceType === 2){
                  item.detailUrl = "/evidenceTaken/snapshotRecord/dataList/Certificate?id=" + item.id + "&type=2";
                }else{
                  item.detailUrl = "/evidenceTaken/screenRecord/dataList/Certificate?id=" + item.id + "&type=2";
                }              }
              if(result.payStatus == 3){
                result.extralDesc += "（退款成功）";
              }else if(result.payStatus == 4){
                result.extralDesc += "（退款失败）";
              }

            });
            this.datas.data = result.datas.result.list;
          }
        });
      },
      confirmDel(id){    //弹出确认删除按钮
          this.delId = id;
          this.modalInfo.msg = "是否确定删除存证记录";
          this.modalInfo.isShown = true;
      },
      removeRecord(){  //彻底删除存证记录
        this.$axios.post('/webapi/personal/delEvidence', {
          snapShotId: this.delId,
          token: this.userInfo.token
        }).then(response => {
          let result = response.data;
          if(result.code == 200){
            this.dataRequest();
          }
        });
      },
      restoreRecord(id, index){  //还原移除的记录
        this.$axios.post('/webapi/personal/operateTask', {
          taskId: id,
          type: 1,
          token: this.userInfo.token
        }).then(response => {
          let result = response.data;
          if(result.code == 200){
            this.dataRequest();
          }
        });
      },
      hideModal(){
          this.modalInfo.isShown = false;
      }
    },
    watch:{
      '$route' (to, from) {
        this.dataRequest();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Trash.vue?a86502a8